module.exports = __webpack_public_path__ + "static/img/pay.17c6b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay.jpg
// module id = Qa9g
// module chunks = 1